import React, {Component} from "react";
import axios from "axios";
import {Link} from "react-router-dom";
import Slider from "react-slick";
import {ROOM_FORM_LINK, ROOM_DETAIL_URL} from "../actions/types";
import BackToUpperLevel from "./BackToUpperLevel.js";
import Calendar from "./Calendar.js";
import IconCount from "../images/icon_count.svg";

// import IconVideo from "../images/icon_video.svg";
// import IconLaptop from "../images/icon_laptop.svg";
// import IconBlackboard from "../images/icon_blackboard.svg";
// import Iconspeaker from "../images/icon_speaker.svg";

import IconVideo from "../images/room/video.svg";
import IconLaptop from "../images/room/laptop.svg";
import IconBlackboard from "../images/room/blackboard.svg";
import Iconspeaker from "../images/room/audio.svg";
import Iconscreen from "../images/room/screen.svg";

import LocationIcon from "@material-ui/icons/LocationOnOutlined";
import moment from "moment";
import "moment/locale/zh-cn";

moment.locale("zh-cn");

class RoomDetail extends Component {
  state = {
    room: {},
    arrangementTime: {},
    arrangements: [],
  };

  componentDidMount() {
    const {id} = this.props.match.params;
    if (id) {
      axios({
        method: "get",
        url: `${ROOM_DETAIL_URL}/${id}`,
      }).then(res => {
        let arrangementTime = {};
        res.data.reservationsList.map(reservation => {
          let timeStamp = moment(reservation.date).valueOf();
          if (arrangementTime[timeStamp]) {
            arrangementTime[timeStamp].push(reservation);
          } else {
            arrangementTime[timeStamp] = [];
            arrangementTime[timeStamp].push(reservation);
          }
          return arrangementTime;
        })
        this.setState({room: res.data, arrangementTime: arrangementTime});
      });
    }
  }

  // 展示排期
  showArrangeView(e, arrangements, timeStamp) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({showArrange: true, arrangements: arrangements || []});
  }

  // 隐藏排期
  hideArrangeView() {
    this.setState({showArrange: false});
  }

  render() {
    const {room} = this.state;
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false
    };

    if (room.id) {
      console.log("4444",this.state.arrangementTime)
      return (
        <React.Fragment>
          <div>
            <BackToUpperLevel title="详情" history={this.props.history}/>
            <div className="container" onClick={() => this.hideArrangeView()}>
              <div className="room-detail">
                <Slider {...settings}>
                  {room.mediaList.map((data, idx) => {
                    return (
                      <div key={idx}>
                        <div style={{backgroundImage: `url(${data.url})`}} className="room-detail-banner"/>
                      </div>
                    );
                  })}
                </Slider>
                <div className="room-detail-desc">
                  <div className="desc-title">{room.name}</div>
                  <div>
                    <img src={IconCount} alt="icon" height={14} style={{marginRight: 4, verticalAlign: "middle"}}/>
                    <span style={{display: "inline-block", verticalAlign: "middle"}}>可容纳{room.capacity}人</span>
                  </div>
                  <div>
                    <LocationIcon
                      style={{color: "rgba(0,0,0,0.45)", fontSize: 14, marginRight: 4, verticalAlign: "middle"}}
                    />
                    <span style={{display: "inline-block", verticalAlign: "middle"}}>{room.address}</span>
                  </div>
                </div>
                {(room.projector_status || room.computer_status || room.board_status) && (
                  <div className="room-detail-equipment">
                    {room.computer_status && (<div>
                      <div className="img-contain">
                        <img src={IconLaptop} alt="icon" width={24} height={24}/>
                      </div>
                      <div className="equipment-desc">有电脑</div>
                    </div>)}
                    {room.board_status && (<div>
                      <div className="img-contain">
                        <img src={Iconscreen} alt="icon" width={24} height={24}/>
                      </div>
                      <div className="equipment-desc">有投影仪</div>
                    </div>)}
                    {room.projector_status && (<div>
                      <div className="img-contain">
                        <img src={IconBlackboard} alt="icon" width={24} height={24}/>
                      </div>
                      <div className="equipment-desc">有黑/白板</div>
                    </div>)}
                    {room.soundDevice_status && (<div>
                      <div className="img-contain">
                        <img src={Iconspeaker} alt="icon" width={24} height={24}/>
                      </div>
                      <div className="equipment-desc">有扩声</div>
                    </div>)}
                    {room.videoEquipment_status && (<div>
                      <div className="img-contain">
                        <img src={IconVideo} alt="icon" width={24} height={24}/>
                      </div>
                      <div className="equipment-desc">有录像</div>
                    </div>)}
                  </div>)}
                <div className="room-detail-content">
                  <div className="content-title">详情</div>
                  <div className="content-text">{room.description}</div>
                </div>
                <div>
                  <div className="content-title">排期</div>
                  <Calendar
                    index={0}
                    arrangementTime={this.state.arrangementTime}
                    arrangements={this.state.arrangements}
                    showArrange={this.state.showArrange}
                    showArrangeView={(e, arrangement, timeStamp) => this.showArrangeView(e, arrangement, timeStamp)}
                    hideArrangeView={() => this.hideArrangeView()}
                  />
                </div>
              </div>
            </div>
            <div>
              <div className="room-detail-bottom">
                <Link to={{pathname: `${ROOM_FORM_LINK}`, state: {room: room}}} className="room-detail-submit">
                  预约
                </Link>
              </div>
            </div>
          </div>
        </React.Fragment>
      );
    } else {
      return <div>loading...</div>;
    }
  }
}

export default RoomDetail;
